import '../styles/whoAmI.scss'
import parisImage from "../images/universiteParis.png"
import brightonImage from "../images/brightonUniversity.png"
import franceImage from "../images/france.png"
import englandImage from "../images/england.png"
import {Fade} from 'react-reveal'
import { useSelector } from 'react-redux'
import { languagesLabels } from '../constants/constants'

const WhoAmI = () => {


    
    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);

    return  <div className = "who-am-i">
                <Fade left>
                <div className = "who-am-i__item">
                    <img className = "who-am-i__image" src = {parisImage}></img>
                    <div className = "who-am-i__text">DUT Informatique / DEST Informatique</div> 
                </div>
                </Fade>
                <i class="fas fa-user-graduate"></i>
                <Fade right>
                <div className = "who-am-i__item">
                    <img className = "who-am-i__image" src = {brightonImage}></img>
                    <div className = "who-am-i__text">BSc Hons Computer Science</div>  
                </div>
                </Fade>
                <Fade left>
                <div className = "who-am-i__item">
                    <img className = "who-am-i__image" src = {franceImage}></img>
                    <div className = "who-am-i__text">{languagesLabels['FR'][currentLanguage]}</div>  
                </div>
                </Fade>
                <i class="fas fa-language"></i>
                <Fade right>
                <div className = "who-am-i__item">
                    <img className = "who-am-i__image" src = {englandImage}></img>
                    <div className = "who-am-i__text">{languagesLabels['EN'][currentLanguage]}</div> 
                </div>
                </Fade>
            </div>
}
export default WhoAmI